"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = void 0;
exports.Features = {
    ANALYTICS_V1: 'FEAT_ANALYTICS_V1',
    PAGE_RESET: 'FEAT_PAGE_RESET',
};
exports.default = exports.Features;
